import { forwardRef } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { ChevronDown, ChevronUp } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { ONBOARDING_AGENT_MESSAGE_SHOW_LESS, ONBOARDING_AGENT_MESSAGE_SHOW_MORE } from "../texts";

import { ExpandToggleButton, UserBubble, UserBubbleText, UserMessageOuter } from "./styles";
import { useOnboardingAgentUserMessage } from "./hooks/useOnboardingAgentUserMessage";

export type OnboardingAgentUserMessageProps = {
    text: string;
};

export const OnboardingAgentUserMessage = forwardRef<HTMLDivElement, OnboardingAgentUserMessageProps>(({ text }, ref) => {
    const { translate } = useTranslate();
    const { textRef, expanded, isOverflowing, isClamped, handleToggleExpanded } = useOnboardingAgentUserMessage(text);

    return (
        <UserMessageOuter
            ref={ref}
            data-automation="onboarding-agent-user-message"
        >
            <UserBubble>
                <UserBubbleText
                    ref={textRef}
                    $clamped={isClamped}
                >
                    {text}
                </UserBubbleText>

                {isOverflowing ? (
                    <ExpandToggleButton
                        buttonHtmlType="button"
                        data-automation={
                            expanded
                                ? "onboarding-agent-user-message-show-less"
                                : "onboarding-agent-user-message-show-more"
                        }
                        aria-expanded={expanded}
                        onClick={handleToggleExpanded}
                    >
                        {expanded ? (
                            <ChevronUp
                                size="xs"
                                color={colorsPalettes.carbon[500]}
                                aria-hidden
                            />
                        ) : (
                            <ChevronDown
                                size="xs"
                                color={colorsPalettes.carbon[500]}
                                aria-hidden
                            />
                        )}
                        {expanded
                            ? translate(ONBOARDING_AGENT_MESSAGE_SHOW_LESS)
                            : translate(ONBOARDING_AGENT_MESSAGE_SHOW_MORE)}
                    </ExpandToggleButton>
                ) : null}
            </UserBubble>
        </UserMessageOuter>
    );
});

OnboardingAgentUserMessage.displayName = "OnboardingAgentUserMessage";
